import { firstStoreObjectOfType, mapRelationships } from '@/store/mappers'

import { signupStepAfter, signupStepUrls } from './signupSteps'

export const answeredSignupColumns = () => {
  const account = firstStoreObjectOfType('onboarding_account')
  const questions = mapRelationships(account?.relationships.onboarding_questions.data)
  const answers = mapRelationships(account?.relationships.onboarding_answers.data)
  const columnsByQuestionId = {}
  questions.forEach(question => {
    columnsByQuestionId[question.id] = question.attributes.target_column
  })
  return answers.map(answer => columnsByQuestionId[answer.relationships.onboarding_question.data.id])
}

// Every journey page calls this after its GET onboarding refill so the URL
// always lands on the step after the furthest answered one - answered steps
// bounce forward, not-yet-reached steps bounce back. The path guard keeps a
// late response from yanking a user who already navigated off the journey.
export const redirectToCurrentSignupStep = router => {
  const path = router.currentRoute.value.path
  if (!signupStepUrls.includes(path)) return
  const currentStep = signupStepAfter(answeredSignupColumns())
  if (currentStep.url !== path) router.replace(currentStep.url)
}
